import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';
import { plainToInstance } from 'class-transformer';
import { ContractData } from '../interfaces/contractData';
import { ContractMap } from '../interfaces/contractMap.model';
import { CopyContract } from '../models/copy-contracts.model';

@Injectable({
  providedIn: 'root'
})
export class ContractService {
  private apiUrl = `${environment.sgcApi}`;
  private contractRoute = 'contract';
  constructor(
    private httpClient: HttpClient
  ) { }

  getContractsByFilter(exerciseId: number, zoneId: number, isStudentsContract: string): Observable<ContractData[]> {
    let zoneIdParam = zoneId.toString().trim();
    let isStudentsContractParam = isStudentsContract.trim();
    let endpoint = `${this.apiUrl}${this.contractRoute}/filter${this.getFilters(exerciseId, zoneIdParam, isStudentsContractParam)}`;
    return this.httpClient.get<any>(endpoint).pipe(map(data => {
      return plainToInstance(ContractData, data as ContractData[]);
    }));
  }

  getContracts(): Observable<ContractData[]> {
    let endpoint = `${this.apiUrl}${this.contractRoute}`;
    return this.httpClient.get<any>(endpoint).pipe(map(data => {
      return plainToInstance(ContractData, data as ContractData[]);
    }));
  }

  getContractsMap(): Observable<ContractMap[]> {
    let endpoint = `${this.apiUrl}${this.contractRoute}/map`;
    return this.httpClient.get<any>(endpoint).pipe(map(data => {
      return plainToInstance(ContractMap, data as ContractMap[]);
    }));
  }

  private getFilters(exerciseId: number, zoneId: string, isStudentsContract: string ) {
    let urlFilter = '?filters=';
    urlFilter += exerciseId.toString() != '' ? 'exerciseId=' + exerciseId + ';' : '';
    urlFilter += zoneId != '' ? 'zoneId=' + zoneId + ';' : '';
    urlFilter += isStudentsContract != '' ? 'contactForStudents=' + isStudentsContract + ';' : '';
    return urlFilter;
  }

  copyContracts(copyContract: CopyContract): Observable<any> {
    let endpoint = `${this.apiUrl}${this.contractRoute}/copyContractsZones/event`;
    return this.httpClient.post(endpoint, JSON.stringify(copyContract));
  }
}
